export const useProviderArgsDefaults = {
  provider: "",
  customOptions: {
    onError: () => {
      /* Do nothing.. */
    },
    transform: (oldData, newData) => newData,
    data: undefined,
    loading: false,
    suspense: false,
    cache: true
  },
  dependencies: undefined
};
export default Object.entries(useProviderArgsDefaults).reduce((acc, _ref) => {
  let [key, value] = _ref;
  if (Object.prototype.toString.call(value) === "[object Object]") return {
    ...acc,
    ...value
  };
  return {
    ...acc,
    [key]: value
  };
}, {});
//# sourceMappingURL=useProviderArgsDefaults.js.map